<template>
    <div class="float-left mr-1" v-if="convenio.idSituacaoConvenio != 9">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Ação"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <acao-form
            operacaoProp="A"
            :acao="acao"
            :mostrarModal="mostrarModal"
            :erros="erros"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></acao-form>
    </div>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'
import AcaoForm from './AcaoForm'

export default {
    components: {
        AcaoForm
    },

    props: {
        convenio: Object,
        acao: Object
    },

    data() {
        return {
            mostrarModal: false,
            erros: []
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(descricao) {
            this.$store.dispatch('addRequest')
            let acao = {
                idAcaoConvenio: this.acao.idAcaoConvenio,
                descricao: descricao
            }
            ConveniosServicos.atualizarAcoes(acao).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Ação atualizada com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarListaAcoes')
                        this.fecharModal()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
